import { render, staticRenderFns } from "./PosAmount.vue?vue&type=template&id=177026ca&scoped=true"
import script from "./PosAmount.vue?vue&type=script&lang=js"
export * from "./PosAmount.vue?vue&type=script&lang=js"
import style0 from "./PosAmount.vue?vue&type=style&index=0&id=177026ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177026ca",
  null
  
)

export default component.exports